var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 339.333V506H506V339.333H6Z",
    fill: "#CA4638"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 339.333H506V172.666V5.99965H6V172.666V339.333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.531 269.462H184.102V322.686H261.531V269.462Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.325 314.904H177.059L166.582 321.8V329.107H224.325",
    fill: "#CA4638"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.325 314.904H177.059L166.582 321.8V329.107H224.325",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.545 284.331C211.35 284.331 216.908 290.004 216.908 296.997V314.879H225.792V247.129H177.059V314.879H192.182V296.997C192.182 290.277 197.644 284.331 204.545 284.331Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.138 201.298H193.728V242.383H216.138V201.298Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216.076 236.013H196.466V229.057H182.087V236.013H172.333V229.057H166.511V241.684H216.076V236.013ZM172.333 241.639H214.641V247.128H172.333V241.639Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.12 186.373V229.057H196.466V217.337C196.466 212.946 199.566 209.353 203.902 209.133C204.042 209.126 204.176 209.133 204.318 209.133C208.851 209.133 212.522 212.805 212.522 217.337V229.057H219.517V186.373H189.12Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "square"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M186.473 180.588V186.372H221.86V180.588H186.473Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "square"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M181.936 169.511V180.588H224.393V169.511H217.853V175.144H209.951V169.511H197.891V175.144H189.989V169.511H181.936Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.582 321.8H224.545Z",
    fill: "#DA000C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.582 321.8H224.545",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M262.05 318.471H222.806L210.972 324.18V332.686H262.05",
    fill: "#CA4638"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M262.05 318.471H222.806L210.972 324.18V332.686H262.05",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "square"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.959 324.165H263.259Z",
    fill: "#CA4638"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M210.959 324.165H263.259",
    stroke: "black",
    strokeWidth: 1.95312
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M276.927 310.267C273.715 311.335 270.813 313.133 267.891 314.807C264.14 317.023 260.502 319.437 257.118 322.185C255.926 322.971 254.783 323.832 253.864 324.936C252.623 325.998 251.366 327.422 251.603 329.186C251.666 329.964 252.66 328.272 253.314 328.19C254.454 327.536 255.835 327.325 257.115 327.62C258.653 326.001 260.636 324.915 262.348 323.499C265.983 320.787 269.893 318.457 273.871 316.288C275.26 315.576 276.655 314.853 278.136 314.35C277.733 312.989 277.33 311.628 276.927 310.267V310.267Z",
    fill: "#F8D80E",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M261.324 319.171V323.904Z",
    fill: "#F8D80E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M261.324 319.171V323.904",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M264.248 317.107V321.805Z",
    fill: "#F8D80E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M264.248 317.107V321.805",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M267.171 315.286V319.954Z",
    fill: "#F8D80E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.171 315.286V319.954",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M270.095 313.488V318.305Z",
    fill: "#F8D80E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M270.095 313.488V318.305",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M235.301 310.418C234.823 311.754 234.344 313.09 233.865 314.426C240.564 316.967 246.942 320.328 252.977 324.177C255.023 325.569 257.172 326.919 258.78 328.83C259.134 329.811 258.158 330.632 257.19 330.335C256.304 330.034 255.431 329.692 254.496 330.33C253.158 330.939 251.948 332.921 253.981 333.586C256.782 335.467 261.339 334.65 262.685 331.354C263.389 329.658 263.434 327.488 262.071 326.097C259.576 323.237 256.267 321.248 253.093 319.236C247.42 315.824 241.511 312.734 235.301 310.418L235.301 310.418Z",
    fill: "#F8D80E",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M253.641 319.95L253.263 323.99Z",
    fill: "#F8D80E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M253.641 319.95L253.263 323.99",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M257.007 322.012L255.964 325.967Z",
    fill: "#F8D80E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M257.007 322.012L255.964 325.967",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M260.603 324.761L258.415 327.83Z",
    fill: "#F8D80E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M260.603 324.761L258.415 327.83",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M261.705 332.225L258.547 330.53Z",
    fill: "#F8D80E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M261.705 332.225L258.547 330.53",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M262.688 328.896L259.064 329.235Z",
    fill: "#F8D80E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M262.688 328.896L259.064 329.235",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M258.015 334.141L257.767 330.956Z",
    fill: "#F8D80E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M258.015 334.141L257.767 330.956",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M256.688 330.5L253.696 332.705Z",
    fill: "#F8D80E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M256.688 330.5L253.696 332.705",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M242.301 313.782V317.551Z",
    fill: "#F8D80E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M242.301 313.782V317.551",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M249.907 317.783V322.059Z",
    fill: "#F8D80E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M249.907 317.783V322.059",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M246.104 315.786V319.801Z",
    fill: "#F8D80E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M246.104 315.786V319.801",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M231.539 404.066V413.783H237.626V408.906H245.906V413.783H252.446V404.066H231.539ZM231.539 417.45V427.204H252.446V417.45H245.906V422.327H237.626V417.45H231.539Z",
    fill: "#F8D80E",
    stroke: "black",
    strokeWidth: 1.95312
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M258.471 363.04H252.434V433.349H258.471V363.04Z",
    fill: "#F8D80E",
    stroke: "black",
    strokeWidth: 1.95312
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M258.471 369.122H252.434V429.687H258.471V369.122Z",
    fill: "#F8D80E",
    stroke: "black",
    strokeWidth: 1.95312
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M255.452 345.806L268.306 353.291L255.452 360.739L242.597 353.291L255.452 345.806ZM238.25 350.607H234.885V355.976H238.25L255.452 365.957L272.654 355.976H276.019V350.607H272.654L255.452 340.626L238.25 350.607Z",
    fill: "#F8D80E",
    stroke: "black",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M255.207 327.506C252.28 327.917 250.094 330.809 250.254 333.718C250.265 338.24 250.231 342.763 250.271 347.284C250.426 350.198 252.971 352.808 255.926 352.835C258.328 353.062 260.74 351.659 261.747 349.472C261.054 349.056 260.361 348.64 259.668 348.225C259.131 349.657 257.583 350.545 256.076 350.38C254.098 350.435 252.496 348.512 252.674 346.588C252.686 342.095 252.65 337.601 252.691 333.109C252.8 331.276 254.548 329.777 256.379 329.964C257.137 329.746 258.178 330.783 258.647 329.888C259.353 328.885 258.145 328.101 257.475 327.544C256.733 327.443 255.957 327.535 255.207 327.506L255.207 327.506ZM262.201 332.232C261.721 333.135 260.729 333.671 259.932 334.144V343.234C260.739 343.7 261.546 344.167 262.352 344.633C262.342 340.757 262.371 336.88 262.338 333.005C262.3 332.766 262.328 332.402 262.201 332.232H262.201Z",
    fill: "#F8D80E",
    stroke: "black",
    strokeWidth: 2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M273.097 175.153H237.615V239.582H273.097V175.153Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M235.131 175.182V229.095H246.397V213.102C246.397 209.414 248.76 204.293 256 204.293C263.241 204.293 265.603 209.414 265.603 213.102V229.095H276.87V175.182H235.131ZM254.261 181.231H257.74V199.681H254.261V181.231ZM244.28 184.86H247.796V198.357H244.28V184.86ZM264.205 184.86H267.721V198.357H264.205V184.86Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M231.312 167.432V175.106H280.689V167.432H231.312Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M226.662 158.509V167.431H285.339V158.509H277.966V163.424H269.649V158.509H260.159V163.424H251.842V158.509H242.352V163.424H234.035V158.509H226.662Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M215.773 247.129V252.687H296.227V247.129H215.773Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M212.484 229.057V247.128H299.516V229.057H291.274V236.013H280.31V229.057H265.603V236.013H246.397V229.057H231.69V236.013H220.726V229.057H212.484Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M222.957 252.687V318.433H238.496V293.821C238.496 282.227 246.234 276.77 256 276.77C265.387 276.77 273.505 282.227 273.505 293.821V318.433H289.044V252.687H222.957Z",
    fill: "#CA4638",
    stroke: "black",
    strokeWidth: 1.95312,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/GI.6a0d477a39b363bd22ef6f8354c936ee.svg";
export { ForwardRef as ReactComponent };